import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center h-50" }
const _hoisted_2 = { class: "d-flex flex-column align-self-center mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center mb-2\"><h1 class=\"bold\">Verify Your Account</h1></div><div class=\"text-center w-75 mb-10 mx-auto\"> The verification token might have expired. Please wait for several minutes for a new email. </div><div class=\"d-flex flex-fill flex-column justify-content-center mb-3 mt-5\"><div class=\"flex-fill w-75 mx-auto\">Didn&#39;t get the email?</div></div>", 3)
const _hoisted_6 = { class: "d-flex flex-fill flex-column justify-content-center mb-3" }
const _hoisted_7 = { class: "flex-fill w-75 mx-auto" }
const _hoisted_8 = ["data-kt-indicator"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Request New Link ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Requesting... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickRequestBtn && _ctx.clickRequestBtn(...args))),
            ref: "btnRequestToken",
            class: "w-100 btn btn-primary rounded-0",
            "data-kt-indicator": _ctx.loading ? 'on' : null
          }, _hoisted_11, 8, _hoisted_8)
        ])
      ])
    ])
  ]))
}